import React from 'react';
import PropTypes from 'prop-types';
import CStudyInformation from '../../components/studies/details/study.information.container';
import Participants from '../../components/participants/participants-component/participants.container';
import DetailedTitledPage from './detailed.titled.page';
import * as consts from '../../const';
import { Tabs, Tab } from 'react-bootstrap';
import DelegationLogContainer from '../../components/delegationlog/delegationlog.container';

class ParticipantsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 1
    };

    this.onTabSelect = this.onTabSelect.bind(this);
  }

  componentDidMount() {
    let studyGid = this.props.match.params.studyGid;
    this.props.publishParticipantsStudyGid(studyGid);
  }

  onTabSelect(key) {
    this.setState({ tab: key });
  }

  render() {
    /**
     * If state is null then means that the page is redirected by sso after login
     * This means that the breadcrumb state will be undefined so here in order to provide the values for
     * breadcrumb state, we use the history.push to redirect to same location adding the values to state
     */
    if (null == this.context.router.route.location.state) {
      const { organizationId = '', organizationName = '' } = this.props.match.params;

      if (this.props.study) {
        this.context.router.history.push(this.context.router.route.location.pathname, {
          forBreadcrumb: {
            studyName: this.props.study.name,
            studyGid: this.props.study.gid,
            organizationId,
            organizationName
          }
        });
      }
    }
    const studyGid = this.props.match.params.studyGid;
    let content = (
      <div>
        <CStudyInformation studyGid={studyGid} />
        <Tabs activeKey={this.state.tab} onSelect={this.onTabSelect} id="participantId">
          <Tab eventKey={1} title={consts.PARTICIPANTS_TAB}>
            <Participants studyGid={studyGid} />
          </Tab>
          <Tab eventKey={2} unmountOnExit title={consts.DELEGATION_LOG_TAB}>
            <DelegationLogContainer studyGid={studyGid} />
          </Tab>
        </Tabs>
      </div>
    );

    return this.props.isStudyGidSet ? <DetailedTitledPage content={content} /> : <div />;
  }
}

ParticipantsPage.contextTypes = {
  router: PropTypes.object.isRequired
};

ParticipantsPage.propTypes = {
  match: PropTypes.object,
  publishParticipantsStudyGid: PropTypes.func,
  fetchDelegationLog: PropTypes.func,
  study: PropTypes.object,
  sponsor: PropTypes.object,
  isStudyGidSet: PropTypes.bool.isRequired
};

export default ParticipantsPage;
